export function installWebAnalytics(token: string): void {
  if (!token || typeof document === 'undefined') {
    return;
  }
  if (document.querySelector('script[data-cf-beacon]')) {
    return;
  }
  const script = document.createElement('script');
  script.type = 'module';
  script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  script.setAttribute('data-cf-beacon', JSON.stringify({ token }));
  document.head.appendChild(script);
}
